// extracted by mini-css-extract-plugin
export default {"toggle-switch":"ToggleSwitch_toggle-switch__Ccuf7","option-label":"ToggleSwitch_option-label__fY9Yl","option-label-checked":"ToggleSwitch_option-label-checked__8rd7H"};